import React, { useState, useEffect } from "react";
import Uploder from "../Uploader";
import { sortsDatas } from "../Datas";
import { Button, Input, Select } from "../Form";
import { BiChevronDown } from "react-icons/bi";
import { toast } from "react-hot-toast";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useFormik } from "formik";
import * as Yup from "yup";
import staffApi from "../../api/staff/staff.api";
import { useNavigate } from "react-router-dom";
import sericesApi from "../../api/service/service.api";
import TimeSlotSelector from "../TimeSlot";
import { MultiSelect } from "../MultiSelect";
import Loading from "../../Util/Loading";
import { useSelector } from "react-redux";

function StaffInfo({ staff }) {
  const { user } = useSelector((state) => state.user);
  // console.log({ user });
  const navigate = useNavigate();

  const [Images, setImages] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [services, setServices] = useState([]);
  const [serviceCategory, setServiceCategory] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  const [selectedDays, setSelectedDays] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);

  const [tempServiceSelection, setTempServiceSelection] = useState(
    staff?.service || []
  );

  const isEdit = !!staff?._id;

  const createStaffForm = useFormik({
    initialValues: {
      email: staff?.email || "",
      name: staff?.name || "",
      phone: staff?.phone || "",
      gender: staff?.gender || "",
      bio: staff?.bio || "",
      photo: staff?.photo || "",
      operator: staff?.operator || "",
      serviceSelected: tempServiceSelection || [],
      timeslot: staff?.timeslot || [],
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Required"),
      name: Yup.string().required("Required"),
      // phone: Yup.string().required("Required"),
      // bio: Yup.string().required("Required"),
      // gender: Yup.string().required("Required"),
      photo: Yup.string().required("Required"),
    }),
    onSubmit: async (values) => {
      try {
        setIsUploading(true);

        console.log("🟡 Submitting form values:", values);

        const payload = {
          ...values,
          service: tempServiceSelection,
          timeslot: timeSlots,
        };

        console.log("📤 Payload to send:", payload);

        const { response, err } = isEdit
          ? await staffApi.updateStaff(staff._id, payload)
          : await staffApi.create(payload);

        if (err) throw new Error(err.message || "Failed to save staff");

        toast.success(isEdit ? "Staff updated" : "Staff created");
        setTimeout(() => navigate(`/staff/preview/${staff._id}`), 1000);
      } catch (error) {
        console.error("❌ Staff save error:", error);

        toast.error(error.message);
      } finally {
        setIsUploading(false);
      }
    },
  });

  const operatorId = user?._id;

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const [serviceRes, serviceCategoryRes] = await Promise.all([
        sericesApi.getallServices({ operatorId }),
        sericesApi.getServiceCategory({ operator: operatorId }),
      ]);

      if (serviceRes?.response?.data?.services)
        setServices(serviceRes?.response?.data?.services);

      if (serviceCategoryRes?.category)
        setServiceCategory(serviceCategoryRes?.category);

      setSelectedServices(staff?.service);
      setImages([staff?.photo]);

      const daysOfWeek = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];

      const enrichedTimeSlots = (staff?.timeslot || []).map((t) => ({
        ...t,
        dayIndex:
          typeof t.dayIndex !== "undefined"
            ? t.dayIndex
            : daysOfWeek.indexOf(t.day),
      }));

      const dayIndices = enrichedTimeSlots.map((t) => t.dayIndex);

      setTimeSlots(enrichedTimeSlots);
      setSelectedDays(dayIndices);

      setIsLoading(false);
    };

    fetchData();
  }, [staff]);

  const updateImages = (url) => {
    setImages([url]);
    createStaffForm.setFieldValue("photo", url);
  };

  console.log({ staff });

  // console.log({ services });

  // console.log({ serviceCategory });

  if (!staff || isLoading) return <Loading />;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        createStaffForm.handleSubmit();
      }}
      className="space-y-4 z-[1000]"
    >
      <Input
        label="Name"
        name="name"
        placeholder="Enter Staff Name"
        value={createStaffForm.values.name}
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        error={createStaffForm.errors.name}
        touched={createStaffForm.touched.name}
      />
      <Input
        label="Email"
        name="email"
        placeholder="Enter Email"
        value={createStaffForm.values.email}
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        error={createStaffForm.errors.email}
        touched={createStaffForm.touched.email}
      />
      {/* <Input
        label="Phone"
        name="phone"
        placeholder="Phone Number"
        value={createStaffForm.values.phone}
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        error={createStaffForm.errors.phone}
        touched={createStaffForm.touched.phone}
      />
      <Input
        label="Bio"
        name="bio"
        placeholder="Bio"
        value={createStaffForm.values.bio}
        onChange={createStaffForm.handleChange}
        onBlur={createStaffForm.handleBlur}
        error={createStaffForm.errors.bio}
        touched={createStaffForm.touched.bio}
      /> */}

      <Select
        selectedPerson={createStaffForm.values.gender}
        setSelectedPerson={(selected) =>
          createStaffForm.setFieldValue("gender", selected.name)
        }
        datas={sortsDatas.genderFilter}
      >
        <div
          className={`w-full bg-dry flex-btn text-textGray text-sm p-4 border font-light rounded-lg ${
            createStaffForm.errors.gender && createStaffForm.touched.gender
              ? "border-red-500"
              : "border-border"
          }`}
        >
          {createStaffForm.values.gender || "Select Gender"}
          <BiChevronDown className="text-xl" />
        </div>
      </Select>
      {createStaffForm.errors.gender && createStaffForm.touched.gender && (
        <p className="text-xs text-red-500 mt-1">
          {createStaffForm.errors.gender}
        </p>
      )}
      <MultiSelect
        title="Services Skills"
        selectedItems={tempServiceSelection}
        setSelectedItems={setTempServiceSelection}
        items={services}
        serviceCategory={serviceCategory}
      />
      {/* <MultiSelect
        title="Nail Skills"
        selectedItems={tempNailSelection}
        setSelectedItems={setTempNailSelection}
        items={nails}
      />
      <MultiSelect
        title="Beauty Skills"
        selectedItems={tempBeautySelection}
        setSelectedItems={setTempBeautySelection}
        items={beauty}
      /> */}

      <TimeSlotSelector
        existingStaff={staff}
        selectedDays={selectedDays}
        setSelectedDays={setSelectedDays}
        timeSlots={timeSlots}
        setTimeSlots={(val) => setTimeSlots(val)}
      />

      <div className="flex gap-3 flex-col w-full col-span-6">
        <p className="text-sm text-text">Profile Image</p>
        <Uploder refreshFunction={updateImages} previewImage={Images[0]} />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
        {!isEdit && (
          <Button
            type="button"
            label="Delete"
            Icon={RiDeleteBin5Line}
            onClick={() => toast.error("This feature is not available yet")}
          />
        )}
        <Button
          type="submit"
          label={isEdit ? "Update" : "Create"}
          loading={isUploading}
          Icon={HiOutlineCheckCircle}
        />
      </div>
    </form>
  );
}

export default StaffInfo;
